import {Icon, IconButton, makeStyles, Menu, MenuItem} from "@material-ui/core";
import styled from "styled-components"
import React, {useContext, useState} from "react";
import {SelectionCriteriaContext} from "./SelectionCriteriaContext";

const StyledContainer = styled.div`
  visibility: hidden;
`

const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const useStyles = makeStyles(({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
}))
const ActionMenu = ({path, index, isPredefinedRequired}) => {
    const [anchorEl, setAnchorEl] = useState(initialContextState)
    const {addGroup, addItem, remove, withoutGroups} = useContext(SelectionCriteriaContext)
    const classes = useStyles();

    function onClose() {
        setAnchorEl(initialContextState)
    }

    return (
        <>
            <StyledContainer id={"advancedFilter_actionMenu"}>
                <IconButton size={"small"} style={{}} onClick={e => setAnchorEl({
                    mouseX: e.clientX - 2,
                    mouseY: e.clientY - 4,
                })}>
                    <Icon style={{color: "#d0d0d0"}} fontSize={"small"}>more_vert</Icon>
                </IconButton>
            </StyledContainer>
            <Menu
                classes={{list: classes.contextPaper}}
                open={anchorEl.mouseY !== null}
                anchorReference={"anchorPosition"}
                anchorPosition={
                    anchorEl.mouseY !== null && anchorEl.mouseX !== null
                        ? {top: anchorEl.mouseY, left: anchorEl.mouseX}
                        : undefined
                }
                onClose={onClose}
            >
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        addItem(path, index, 0)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Add before
                </MenuItem>
                {!withoutGroups && (
                    <MenuItem
                        dense
                        classes={{root: classes.menuItemRoot}}
                        onClick={(e) => {
                            e.stopPropagation();
                            addGroup(path, index, 0)
                            onClose();
                        }}
                    >
                        {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                        {/*    <Edit fontSize="small"/>*/}
                        {/*</ListItemIcon>*/}
                        Add before group
                    </MenuItem>
                )}
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        addItem(path, index, 1)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Add after
                </MenuItem>
                {!withoutGroups && (
                    <MenuItem
                        dense
                        classes={{root: classes.menuItemRoot}}
                        onClick={(e) => {
                            e.stopPropagation();
                            addGroup(path, index, 1)
                            onClose();
                        }}
                    >
                        {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                        {/*    <Edit fontSize="small"/>*/}
                        {/*</ListItemIcon>*/}
                        Add after group
                    </MenuItem>
                )}
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    disabled={isPredefinedRequired}
                    onClick={(e) => {
                        e.stopPropagation();
                        remove(path, index)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Remove
                </MenuItem>
            </Menu>
        </>
    )
}

export default ActionMenu;